<template>
    <div class="count-down" :class="is_exam ? 'is-exam' : ''">
        <i class="iconfont">&#xe662;</i>
        <span style="margin-right: 10px;">{{timeText}}</span>
        <span>{{countDownList}}</span>
    </div>
</template>

<script>
    export default {
        name: "CountDown",
        props: {
          timeObj: Object
        },
        data() {
            return {
                //倒计时
                timeText: '',
                countDownList: '00 : 00 : 00 : 00',
                actBeginTime: '',
                actEndTime: '',
                is_exam: false
            }
        },
        mounted() {
            if (this.$route.path === '/student/exam') {
                this.is_exam = true;
            }
          let timeSet = setInterval(()=>{
            if(this.timeObj.end_time !== null){
              this.getStudentComeInfo();
              this.countDown();
              clearInterval(timeSet);
            }
          },500)
        },
        methods: {
            //获取比赛信息
            getStudentComeInfo() {
              this.actBeginTime = this.timeObj.begin_time;
              this.actEndTime = this.timeObj.end_time;
            },
            //倒计时
            timeFormat(param) {
                return param < 10 ? '0' + param : param;
            },
            countDown() {
                var interval = setInterval(() => {
                    // 获取当前时间
                    let newTime = Math.round(new Date() / 1000);
                    //获取开始时间，结束时间
                    let endTime = this.actEndTime;
                    let startTime = this.actBeginTime;

                    let obj = null;
                    //开始比赛
                    if (newTime - startTime > 0) {
                        this.timeText = '距离考试结束还有：';
                        // 如果活动未结束，对时间进行处理
                        if (endTime - newTime > 0) {
                            let time = endTime - newTime;
                            // 获取天、时、分、秒
                            let day = parseInt(time / (60 * 60 * 24));
                            let hou = parseInt(time % (60 * 60 * 24) / 3600);
                            let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
                            let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
                            obj = {
                                day: this.timeFormat(day),
                                hou: this.timeFormat(hou),
                                min: this.timeFormat(min),
                                sec: this.timeFormat(sec)
                            };
                            if(this.$route.name === 'studentExam'){
                              // 1是开始
                              this.$emit('changeBeginExam',1)
                            }
                        } else { // 活动已结束，全部设置为'00'
                            obj = {
                                day: '00',
                                hou: '00',
                                min: '00',
                                sec: '00'
                            };
                            clearInterval(interval);
                            this.$message({
                                type: 'error',
                                message: '考试时间到！停止作答！',
                                duration: '1000'
                            });
                            this.$router.push('/');
                            // this.$emit('update:endDialog', true)
                        }
                        this.countDownList = obj.day + ' : ' + obj.hou + ' : ' + obj.min + ' : ' + obj.sec + '';

                        //比赛或者训练结束时，结束推广
                        if (this.countDownList === '00 : 00 : 00 : 00') {
                            let formData = new FormData();
                            // this.$http.axiosPost(this.$api.storedrainage_endoperation, formData, (res) => {
                            //     if (res.code === 200) {
                            //         this.$router.push('/student/index');
                            //     } else {
                            //         this.$message.warning(res.msg);
                            //     }
                            // }, (err) => {
                            //     console.log(err);
                            // })
                        }
                    } else { //还未开始比赛
                        if(this.$route.name === 'studentExam'){
                          // 2是未开始
                          this.$emit('changeBeginExam',2)
                        }
                        this.timeText = '距离考试开始还有：';
                        let time = startTime - newTime;
                        //当时间差为0时，刷新页面
                        if (time === 0){
                            window.location.reload();
                        }
                        // 获取天、时、分、秒
                        let day = parseInt(time / (60 * 60 * 24));
                        let hou = parseInt(time % (60 * 60 * 24) / 3600);
                        let min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
                        let sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
                        obj = {
                            day: this.timeFormat(day),
                            hou: this.timeFormat(hou),
                            min: this.timeFormat(min),
                            sec: this.timeFormat(sec)
                        };
                        this.countDownList = obj.day + '：' + obj.hou + '：' + obj.min + '：' + obj.sec + '';
                    }
                }, 1000);
            }
        }
    }
</script>

<style scoped lang="scss">
    .count-down {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #333;
        font-weight: 500;
        i {
            color: #F23B2F;
            font-size: 20px;
            margin-right: 10px;
        }
    }
    .is-exam {
        color: #333;
        i {
            color: #F23B2F;
        }
    }
</style>